import '../scss/user/global.scss';

import { createRoot } from 'react-dom/client';
import { createInertiaApp, router } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';

import * as Sentry from '@sentry/react';
import { EnvironmentRibbon } from './Components/Common/EnvironmentRibbon';

// const appName = import.meta.env.VITE_APP_NAME || 'Laravel';
const appName = '内見予約ナビ';

// Sentry
Sentry.init({
    environment: import.meta.env.VITE_APP_ENV,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            // マスキングを無効化
            maskAllText: false,
            maskAllInputs: false,
            // 特定の要素のみマスクしたい場合
            // mask: ['.password', '.credit-card'],
            // block: ['.sensitive-data'],
        }),
    ],
    tracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1,
    ignoreErrors: ['Error: Page not found: ./Pages/undefined.tsx'], // viteの不具合 @see:https://github.com/inertiajs/inertia/issues/2091
});

// ===== Clarityで追跡する画面の出しわけ。コード側から直接イベントをpushする ======

// Clarityの追跡を除外するURLパスのリスト
const CLARITY_EXCLUDE_PATHS = [
    '/login',
    '/register',
    '/register/confirm',
    '/register/sms',
    '/register/complete',
    '/password/reset',
    '/password/sms-sent',
    '/password/complete',
    '/password',
];

// Inertiaのページ遷移（初回ロード時およびSPA遷移完了時）に発火
router.on('navigate', (event) => {
    window.dataLayer = window.dataLayer || [];

    const page = event.detail.page;
    // componentが 'User/Error' かつ statusが 404 の場合は除外対象とする
    const isError404 = page.component === 'User/Error' && page.props?.status === 404;

    // page.urlからホスト名を除いたパス部分を取得
    const currentPath = new URL(page.url, window.location.origin).pathname;

    // 完全一致、またはサブパス（例: /password/reset）のみを安全に除外判定する
    const isExcludePath = CLARITY_EXCLUDE_PATHS.some((path) =>
        currentPath === path || currentPath.startsWith(`${path}/`)
    );

    if (isExcludePath || isError404) {
        window.dataLayer.push({
            event: 'clarity_disable',
            page_path: currentPath,
        });
    } else {
        window.dataLayer.push({
            event: 'clarity_enable',
            page_path: currentPath,
        });
    }
});

// ==================================

createInertiaApp({
    title: (title) => {
        const isLpPage = window.location.pathname === '/lp';
        return isLpPage ? title : `${title} - ${appName}`;
    },
    resolve: (name) => resolvePageComponent(`./Pages/${name}.tsx`, import.meta.glob('./Pages/**/*.tsx')),
    setup({ el, App, props }) {
        const root = createRoot(el);
        root.render(
            <>
                <EnvironmentRibbon />
                <App {...props} />
            </>
        );
    },
    progress: {
        color: '#4B5563',
    },
});
